<div class="patient">
  <div class="wrapper">
    <!-- POP UP FOR XML LOADING -->
    <div
      style="top: 30%; width: 700px"
      *ngIf="xmlLoading"
      class="print-history-popup"
    >
      <div class="print-history-popup-body">
        <h2 class="popup-title">הפעולה עשויה להימשך 2-3 דקות, נא להמתין</h2>
      </div>
    </div>
    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div
        class="l-header-panel"
        style="display: flex; justify-content: space-between"
      >
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main">
            {{
              AWLlist ? "TodayList" : examList || xmlList ? "Exams" : "Patients"
            }}
          </h1>
          <div
            class="l-flex l-flex-c t-field t-field-pad"
            *ngIf="AWLlist"
            style="margin-left: 2em"
          >
            <label> Status </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="AWLStatus"
              (change)="
                AWLStatus !== 'Completed' && AWLStatus !== 'Interpreted'
                  ? AWLExam == 'All' && (location = null)
                  : null;
                AWL();
                startdate = null;
                enddate = null
              "
            >
              <option value="All">All</option>
              <option value="Waiting">Scheduled</option>
              <option value="Received">Waiting</option>
              <option value="In Progress">In Progress</option>

              <option value="Completed">Waiting for Interpretation</option>
              <option value="Interpreted">Interpreted</option>
            </select>
          </div>
        </div>
        <span
          *ngIf="
            AWLlist && (AWLStatus == 'Completed' || AWLStatus == 'Interpreted')
          "
          style="margin-left: 1em"
        >
          Exam Type
          <select
            class="t-field t-select"
            [(ngModel)]="AWLExam"
            (change)="AWL()"
          >
            <option value="All">All</option>
            <option *ngFor="let name of examTypes" [value]="name">
              {{ name }}
            </option>
          </select>
        </span>
        <span
          *ngIf="
            AWLlist && (AWLStatus == 'Completed' || AWLStatus == 'Interpreted')
          "
          style="margin-left: 1em"
          (dblclick)="startdate = null; enddate = null; AWL()"
        >
          From
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [max]="enddate"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
            (ngModelChange)="AWL()"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          Until
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [min]="startdate"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (ngModelChange)="AWL()"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
          <span
            *ngIf="startdate || enddate"
            style="
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 1.5em;
              height: 1.5em;
              margin-left: 0.5em;
              border-radius: 50%;
              background-color: rgba(255, 255, 255, 0.25);
              color: #fff;
              font-size: 1em;
              line-height: 1;
              cursor: pointer;
              vertical-align: middle;
            "
            (click)="startdate = null; enddate = null; AWL()"
            matTooltip="Clear date filter"
            >&#215;</span
          >
        </span>
        <span
          *ngIf="
            !crossMode &&
            AWLlist &&
            (AWLStatus == 'Completed' || AWLStatus == 'Interpreted')
          "
          style="margin-left: 1em"
        >
          Location
          <select
            class="t-field t-select"
            [(ngModel)]="location"
            (change)="AWL()"
          >
            <option [value]="null">All</option>
            <option
              *ngFor="let name of loginService.clinicConnectors"
              [value]="name"
            >
              {{ name }}
            </option>
          </select>
        </span>
        <!-- Sites: filter the aggregated TodayList down to one site -->
        <span *ngIf="crossMode && AWLlist" style="margin-left: 1em">
          Site
          <select
            class="t-field t-select"
            [(ngModel)]="siteFilter"
            (change)="AWL()"
          >
            <option [ngValue]="null">All sites</option>
            <option *ngFor="let s of sites.sites" [ngValue]="s.GID">
              {{ s.ClinicTitle }}
            </option>
          </select>
        </span>
        <span *ngIf="crossMode && AWLlist" style="margin-left: 1em">
          <button
            class="search-btn"
            (click)="openSiteStats()"
            matTooltip="Waiting per clinic"
          >
            Site Stats
          </button>
        </span>
        <!-- ======== Reports Exams Count (Start)  -->
        <ng-container *ngIf="isReports">
          <div
            *ngIf="examList && examList.length > 0"
            style="display: flex; gap: 1em; margin: 1em"
          >
            <ng-container
              *ngIf="loginService.premissions && loginService.premissions.FOV"
            >
              <span>
                FOV: {{ examList ? filterExams(examList, "FOV").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions &&
                !loginService.premissions.OCTOptic &&
                !loginService.premissions.OCTMacular
              "
            >
              <span>
                OCT: {{ examList ? filterExams(examList, "OCT").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions && loginService.premissions.OCTOptic
              "
            >
              <span>
                OCT Optic:
                {{ examList ? filterExams(examList, "OCTOptic").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions && loginService.premissions.OCTMacular
              "
            >
              <span>
                OCT Macular:
                {{ examList ? filterExams(examList, "OCTMacular").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions && loginService.premissions.TOPEye
              "
            >
              <span>
                TOP Eye:
                {{ examList ? filterExams(examList, "TOPEye").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions && loginService.premissions.Pachymetry
              "
            >
              <span>
                Pachymetry:
                {{ examList ? filterExams(examList, "Pachymetry").length : 0 }}
              </span>
            </ng-container>

            <ng-container
              *ngIf="
                loginService.premissions && loginService.premissions.Fundus
              "
            >
              <span>
                Fundus:
                {{ examList ? filterExams(examList, "Fundus").length : 0 }}
              </span>
            </ng-container>

            <span> Number Of Exams: {{ examList ? examList.length : 0 }} </span>
          </div>
          <div style="display: inline-flex">
            <span
              (click)="export()"
              class="header-menu-link icon-file"
              aria-label="Export"
              matTooltip="Export to Excel"
              *ngIf="examList && examList.length > 0"
            >
            </span>
            <span
              (click)="showprintopts = true; showprint = true"
              class="header-menu-link icon-print"
              aria-label="Print"
              matTooltip="Print"
            ></span>
          </div>
        </ng-container>

        <button
          class="search-btn search-btn--newPatient"
          *ngIf="AWLlist && loginService.barcodeScan && !swiping"
          style="margin-left: auto; width: 8em"
          (click)="swiping = true; getcard()"
        >
          Scan barcode
        </button>
        <input
          *ngIf="AWLlist && loginService.isCardio && swiping"
          #swipeField
          (keyup)="proccesscard($event)"
          [(ngModel)]="card"
        />
        <input
          *ngIf="AWLlist && loginService.barcodeScan && swiping"
          #swipeField
          (keyup)="barscan($event)"
          [(ngModel)]="card"
        />
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        <!-- =============== Doctor Selection (Start) =============== -->
        <div
          *ngIf="
            (loginService.isAdmin || loginService.userType == 'secretary') &&
            (loginService.separatedClinic || loginService.SeparateZimun) &&
            !loginService.isCardio
          "
          style="position: absolute; right: 4em"
        >
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="שם הרופא">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                [(ngModel)]="loginService.doctor"
                (ngModelChange)="AWL()"
                class="t-select w100"
                style="text-align: center"
              >
                <option [value]="null">All</option>
                <ng-container *ngFor="let e of getDoctors()">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>
        <!-- =============== Doctor Selection (End) =============== -->
        <img
          style="
            cursor: pointer;
            position: absolute;
            right: 3%;
            top: 50%;
            transform: translateY(-50%);
          "
          matTooltip="Download CSV"
          *ngIf="
            examList &&
            examList.length &&
            (loginService.userType === 'admin' ||
              loginService.premissions.Stats)
          "
          (click)="generateXlExams(examList)"
          height="31em"
          src="../../assets/icons/file.svg"
        />
      </div>
    </header>
    <!-- ========================== header (end) ========================== -->

    <!-- Sites: block-and-confirm clinic switch prompt. Floats next to the exact
         row/link that was clicked (see SiteSwitchPromptComponent) instead of a
         page-top banner disconnected from the click. -->
    <app-site-switch-prompt></app-site-switch-prompt>

    <!-- ========================== intro (start) ========================== -->

    <main class="l-deashboard">
      @if (searchLoading) {
        <div class="list-spinner-wrap" [class.is-leaving]="searchFading">
          <img
            src="assets/images/Wedges.svg"
            alt="Loading..."
            class="list-spinner-img"
          />
        </div>
      } @else {
        <ng-container>
          @if (isAWL && AWLlist && AWLlist.length === 0) {
            @if (AWLStatus && AWLStatus != "All") {
              <p style="padding: 2rem; text-align: center">
                {{
                  "GUI.Patients.empty.today status"
                    | translate
                      : {
                          status:
                            "GUI.Patients.todaylist.statues." +
                              (AWLStatus == "Completed"
                                ? "Waiting for Interpretation"
                                : AWLStatus == "Waiting"
                                  ? "Scheduled"
                                  : AWLStatus)
                            | translate,
                        }
                }}
              </p>
            } @else {
              <p style="padding: 2rem; text-align: center">
                {{ "GUI.Patients.empty.today" | translate }}
              </p>
            }
          }
          <div
            class="l-flex patient-item"
            *ngFor="let pat of AWLlist; index as i"
          >
            <div class="w100 patient-item-link">
              <div class="l-table h100">
                <span
                  class="l-td-m patient-item-cell patient-id"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  Time:
                  <strong>{{
                    AWLStatus == "Completed" || AWLStatus == "Interpreted"
                      ? (pat.ExamDate | date: "d/M/yy, h:mm a")
                      : (pat.ExamDate | date: "shortTime")
                  }}</strong>
                </span>
                <span
                  class="l-td-m patient-item-cell patient-id"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  ID: <strong>{{ pat.ID }}</strong>
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  [ngClass]="pat.Reason ? 'type-v' : 'type-plus'"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  {{ pat.First }} {{ pat.Last }}
                  <span
                    class="anatomy-show-more"
                    style="bottom: auto; right: auto"
                    *ngIf="
                      (!loginService.ishospital ||
                        loginService.ishospital == 'belinson') &&
                      !loginService.isGastro
                    "
                  >
                    <div class="on-hoverPanel">
                      <div class="on-hoverPanel-body">
                        <div class="anatomy-item-details">
                          <div class="anatomy-items-desc">
                            <div
                              class="anatomy-items-edited scroller mCustomScrollbar _mCS_2 mCS_no_scrollbar"
                              contenteditable="true"
                            >
                              <div
                                id="mCSB_2"
                                class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                                tabindex="0"
                                style="max-height: none"
                              >
                                <div
                                  id="mCSB_2_container"
                                  class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                                  style="position: relative; top: 0; left: 0"
                                  dir="ltr"
                                ></div>
                                <div
                                  id="mCSB_2_scrollbar_vertical"
                                  class="mCSB_scrollTools mCSB_2_scrollbar mCS-light mCSB_scrollTools_vertical"
                                  style="display: none"
                                >
                                  <div class="mCSB_draggerContainer">
                                    <div
                                      id="mCSB_2_dragger_vertical"
                                      class="mCSB_dragger"
                                      style="
                                        position: absolute;
                                        min-height: 30px;
                                        top: 0px;
                                        display: block;
                                        height: 12px;
                                        max-height: 106.938px;
                                      "
                                    >
                                      <div
                                        class="mCSB_dragger_bar"
                                        style="line-height: 30px"
                                      ></div>
                                    </div>
                                    <div class="mCSB_draggerRail"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <textarea
                              class="anatomy-items-edit"
                              (click)="$event.stopPropagation()"
                              (change)="saveComment(pat.Reason, pat.AWLID)"
                              [(ngModel)]="pat.Reason"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="loginService.ishospital"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  <ng-container *ngIf="pat.Locked"
                    >Open By: {{ pat.LockedBy }} at
                    {{ pat.Locked | date: "shortTime" }}</ng-container
                  >
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-last"
                  *ngIf="loginService.ishospital && !loginService.AWLExamNames"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  Address: {{ pat.Address }} {{ pat.City }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="!loginService.ishospital"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  Phone: {{ pat.Phone ? pat.Phone : pat.Mobile }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    (!loginService.ishospital || loginService.AWLExamNames) &&
                    pat.ExamCode
                  "
                >
                  {{ pat.ExamCode }}
                  <ng-container *ngIf="loginService.premissions.Consent">
                    <img
                      src="../../assets/icons/login/text-file-icon.svg"
                      style="height: 1.5em; width: 1.5em"
                      matTooltip="Open Consent Form"
                      (click)="startForm(pat)"
                    />
                  </ng-container>
                  <ng-container
                    *ngIf="
                      loginService.premissions &&
                      loginService.premissions.Questionnaires
                    "
                  >
                    <span style="position: relative; display: inline-block">
                      <img
                        src="../../assets/icons/chat.svg"
                        style="height: 1.5em; width: 1.5em; cursor: pointer"
                        matTooltip="Send Questionnaire"
                        (click)="
                          $event.stopPropagation(); openSendQuestionnaire(pat)
                        "
                      />
                      <span
                        *ngIf="patQuestionnaireAnswered[pat.AWLID]"
                        style="
                          position: absolute;
                          bottom: -0.1em;
                          right: -0.4em;
                          font-size: 0.75em;
                          color: green;
                          font-weight: bold;
                          background: white;
                          border-radius: 50%;
                          line-height: 1;
                          padding: 0 1px;
                        "
                        >✓</span
                      >
                    </span>
                  </ng-container>
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    (!loginService.ishospital || loginService.AWLExamNames) &&
                    !pat.ExamCode &&
                    loginService.isCardio
                  "
                >
                  <select
                    class="t-field t-select"
                    [(ngModel)]="changedExamCode"
                    (ngModelChange)="setExamCode(pat)"
                  >
                    <option
                      *ngFor="let name of eyesTodayListExams"
                      [value]="name"
                    >
                      {{ name }}
                    </option>
                  </select>
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    loginService.separatedClinic &&
                    (loginService.isAdmin ||
                      loginService.userType == 'secretary')
                  "
                >
                  {{ loginService.getDocByUID(pat.UID) }}
                </span>
                <!-- <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="!loginService.ishospital && !loginService.isCardio && !loginService.isGastro"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ pat.ExamLMP ? "LMP: " + (pat.ExamLMP | date : "d.M.yyyy") : "" }}
                {{ GaArray ? "GA: " + GaArray[i] : "-1w -1d" }}
              </span> -->
                <span
                  class="l-td-m patient-item-cell patient-site"
                  *ngIf="crossMode"
                  [matTooltip]="sites.byId[pat['GID']]?.ClinicTitle"
                >
                  {{ sites.byId[pat["GID"]]?.ClinicTitle }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="crossMode && AWLStatus == 'Interpreted'"
                >
                  {{ pat.Signer }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  (click)="setAWL(pat); selectedPatient = pat"
                >
                  {{ getStatus(pat.Status) }}
                </span>
              </div>
            </div>
            <!-- Cross-clinic: silent site-switch before opening -->
            <a
              *ngIf="crossMode"
              class="l-td-m patient-item-exit"
              style="cursor: pointer"
              (click)="openAwlRow(pat, $event)"
            ></a>
            <a
              *ngIf="!crossMode"
              class="l-td-m patient-item-exit"
              routerLink="/exams"
              (click)="
                patservice.setPat(pat);
                setPatAwlid(pat);
                patservice.lastAwlDate = pat['ExamDate']
              "
              [state]="{ data: pat }"
            ></a>
          </div>
        </ng-container>

        <div
          class="pagination-controls"
          *ngIf="
            isAWL &&
            (AWLStatus == 'Interpreted' || AWLStatus == 'Completed') &&
            (awlHasMore || awlPage > 1)
          "
        >
          <button
            class="flip-page"
            (click)="previousAwlPage()"
            [disabled]="awlPage === 1"
            matTooltipPosition="before"
            matTooltip="Go To Previous Page"
          >
            Previous
          </button>
          <span>Page {{ awlPage }}</span>
          <button
            class="flip-page"
            (click)="nextAwlPage()"
            [disabled]="!awlHasMore"
            matTooltipPosition="after"
            matTooltip="Go To Next Page"
          >
            Next
          </button>
        </div>

        @if (patList && patList.length === 0 && !isAWL) {
          <p style="padding: 2rem; text-align: center">
            {{ "GUI.Patients.empty.patients" | translate }}
          </p>
        } @else if (patList && !isAWL) {
          <app-pagination-controls
            [total]="totalResults"
            [page]="currentPage"
            [totalPages]="totalPages"
            (prev)="previousPage()"
            (next)="nextPage()"
          ></app-pagination-controls>
          <div class="l-flex patient-item" *ngFor="let pat of patList">
            <button
              class="w100 patient-item-link"
              (click)="openSearchPatient(pat, $event)"
              matTooltip="Open Patient Record"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-id">
                  {{ pat.IsID ? "ID" : "Passport" }}:
                  <strong>{{ pat.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  {{ pat.First }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-last">
                  {{ pat.Last }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    loginService.separatedClinic &&
                    (loginService.isAdmin ||
                      loginService.userType == 'secretary')
                  "
                >
                  {{ loginService.getDocByUID(pat.UID) }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-site"
                  *ngIf="sites.activeSite === 'all'"
                  [matTooltip]="sites.byId[pat['GID']]?.ClinicTitle"
                >
                  {{ sites.byId[pat["GID"]]?.ClinicTitle }}
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              style="cursor: pointer"
              (click)="openSearchPatientHistory(pat, $event)"
              matTooltip="Open Patient History"
            ></a>
          </div>
          @if (patList.length >= pageSize && totalPages > 1) {
            <app-pagination-controls
              [total]="totalResults"
              [page]="currentPage"
              [totalPages]="totalPages"
              (prev)="previousPage()"
              (next)="nextPage()"
            ></app-pagination-controls>
          }
        }
      }
      <div
        *ngIf="exServ.searchReport"
        style="
          margin: 10px;
          padding: 10px;
          border-radius: 10px;
          border: 1px solid grey;
        "
      >
        <div
          class="w100"
          style="
            display: flex;
            justify-content: space-evenly;
            flex-direction: row-reverse;
          "
        >
          <span style="margin: 0 5px">
            <label style="margin: 0 5px; font-weight: 700">חיפוש לפי</label>
            <span
              style="margin: 0 5px"
              *ngIf="exServ.searchReport.type == 'Macabi'"
              >בדיקות שנשלחו למכבי</span
            >
            <span
              style="margin: 0 5px"
              *ngIf="exServ.searchReport.type == 'Refferelnum'"
              >מס' הפניה חסר</span
            >
            <span
              style="margin: 0 5px"
              *ngIf="exServ.searchReport.type == 'HMO'"
              >{{ getHMO(exServ.searchReport.hmo) }}</span
            >
          </span>
          <span
            style="margin: 0 5px; display: flex; flex-direction: row-reverse"
          >
            <label style="margin: 0 5px; font-weight: 700">תאריכים</label>
            <div style="display: flex; flex-direction: row">
              <span>
                {{ exServ.searchReport.start | date: "dd/MM/yyyy" }}
              </span>
              <label>-</label>
              <span>{{ exServ.searchReport.end | date: "dd/MM/yyyy" }}</span>
            </div>
          </span>
        </div>
      </div>

      @if (examListLoading) {
        <div class="list-spinner-wrap" [class.is-leaving]="examListFading">
          <img
            src="assets/images/Wedges.svg"
            alt="Loading..."
            class="list-spinner-img"
          />
        </div>
      } @else {
        @if (examList && examList.length === 0) {
          <p style="padding: 2rem; text-align: center">
            {{ "GUI.Patients.empty.exams" | translate }}
          </p>
        }
        <div *ngFor="let name of examNames" style="margin: 1em 0">
          <div
            class="l-flex"
            *ngIf="filterExams(examList, name).length > 0"
            style="display: flex; justify-content: space-between"
          >
            <span style="font-size: x-large">
              <strong> {{ "exam.type.Eyes." + name | translate }} </strong>

              <!-- =============== Exams Limits by HMO (Start) =============== -->
              <ng-container *ngIf="loginService.limits">
                <div class="l-flex r-hmos">
                  <span
                    [ngClass]="
                      examList &&
                      filterExams(examList, name, 'Leumit').length >=
                        loginService.limits[getDbName(name, 'Leumit')]
                        ? 'error'
                        : ''
                    "
                    *ngIf="
                      loginService.limits &&
                      loginService.limits[getDbName(name, 'Leumit')]
                    "
                    style="font-size: x-large"
                  >
                    <strong>
                      Leumit:
                      {{ filterExams(examList, name, "Leumit").length }}/{{
                        loginService.limits[getDbName(name, "Leumit")]
                      }}
                    </strong></span
                  >
                  <span
                    [ngClass]="
                      examList &&
                      filterExams(examList, name, 'Macabi').length >=
                        loginService.limits[getDbName(name, 'Macabi')]
                        ? 'error'
                        : ''
                    "
                    *ngIf="
                      loginService.limits &&
                      loginService.limits[getDbName(name, 'Macabi')]
                    "
                    style="font-size: x-large"
                  >
                    <strong>
                      Macabi:
                      {{ filterExams(examList, name, "Macabi").length }}/{{
                        loginService.limits[getDbName(name, "Macabi")]
                      }}
                    </strong>
                  </span>
                  <span
                    [ngClass]="
                      examList &&
                      filterExams(examList, name, 'Meuhedet').length >=
                        loginService.limits[getDbName(name, 'Meuhedet')]
                        ? 'error'
                        : ''
                    "
                    *ngIf="
                      loginService.limits &&
                      loginService.limits[getDbName(name, 'Meuhedet')]
                    "
                    style="font-size: x-large"
                  >
                    <strong>
                      Meuhedet:
                      {{ filterExams(examList, name, "Meuhedet").length }}/{{
                        loginService.limits[getDbName(name, "Meuhedet")]
                      }}
                    </strong>
                  </span>
                  <span
                    [ngClass]="
                      examList &&
                      filterExams(examList, name, 'Clalit').length >=
                        loginService.limits[getDbName(name, 'Clalit')]
                        ? 'error'
                        : ''
                    "
                    *ngIf="
                      loginService.limits &&
                      loginService.limits[getDbName(name, 'Clalit')]
                    "
                    style="font-size: x-large"
                  >
                    <strong>
                      Clalit:
                      {{ filterExams(examList, name, "Clalit").length }}/{{
                        loginService.limits[getDbName(name, "Clalit")]
                      }}
                    </strong>
                  </span>
                </div>
              </ng-container>
              <!-- =============== Exams Limits by HMO (End) =============== -->
            </span>
          </div>
          <div
            class="l-flex patient-item"
            *ngFor="let exam of filterExams(examList, name)"
          >
            <button
              class="w100 patient-item-link"
              (click)="goPatient(exam, $event)"
              matTooltip="Click to View Patient History"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Time:
                  <strong>{{
                    exam.CreationTime | date: "dd/MM/yyyy h:mm a"
                  }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  ID: <strong>{{ exam.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-id">
                  Name: {{ exam.First }} {{ exam.Last }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Type:
                  <strong>
                    {{ "exam.type.Eyes." + exam.ExamType | translate }}
                    <span *ngIf="exam.Changed"
                      >({{ exam.ChangedExamTitle }})</span
                    ></strong
                  >
                </span>
                <span
                  class="l-td-m patient-item-cell patient-site"
                  *ngIf="sites.activeSite === 'all'"
                  [matTooltip]="sites.byId[exam['GID']]?.ClinicTitle"
                >
                  {{ sites.byId[exam["GID"]]?.ClinicTitle }}
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              [ngClass]="getLocked(exam)"
              (click)="goExam(exam, $event)"
              [matTooltip]="
                getLocked(exam) === 'locked'
                  ? 'Locked By: ' + exam.LockedBy
                  : 'View Exam'
              "
            ></a>
          </div>
        </div>
      }

      <div>
        <img
          *ngIf="xmlLoading"
          src="../../assets/images/Wedges.svg"
          style="
            z-index: 0;
            margin-left: auto;
            margin-right: auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 40vh;
          "
        />
        <div class="l-flex patient-item" *ngFor="let xml of xmlList">
          <div class="l-table h100">
            <span class="l-td-m patient-item-cell">
              Exam Time:
              <strong>{{
                xml.CreationTime | date: "dd/MM/yyyy h:mm a"
              }}</strong>
            </span>
            <span class="l-td-m patient-item-cell patient-id">
              ID: <strong>{{ xml.ID }}</strong>
            </span>

            <span class="l-td-m patient-item-cell patient-id">
              Name: {{ xml.First }} {{ xml.Last }}
            </span>

            <span class="l-td-m patient-item-cell">
              Exam Type:
              <strong
                >{{ xml.ExamType }}
                <span *ngIf="xml.Changed"
                  >({{ xml.ChangedExamTitle }})</span
                ></strong
              >
            </span>
            <span class="l-td-m patient-item-cell">
              Xml File Name: <strong>{{ xml.xmlName }} </strong>
            </span>
          </div>
        </div>
      </div>
    </main>

    <!-- ========================== main sidebar (start) ========================== -->

    <aside class="l-sidebar l-flex l-column">
      <img
        class="off-mobile sidebar-logo"
        src="assets/icons/logo.svg"
        alt="Artisan Sonics"
      />

      <!-- user panel (start) -->
      <div class="userPanel">
        <i class="userPanel-icon icon-female"> </i>

        <div class="userPanel-userName">Patient Search</div>

        <div class="search-patient">
          <div class="search-patient-field">
            <div class="t-field l-flex t-twin-fieldset">
              <label>
                <input
                  type="radio"
                  name="idp"
                  [(ngModel)]="idp"
                  [value]="1"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> ID </span>
              </label>
              <label>
                <input
                  type="radio"
                  name="idp"
                  [value]="0"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> Passport </span>
              </label>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field idnumber"
              [ngClass]="invalidi"
              placeholder="ID Number"
              [(ngModel)]="id"
              (keyup)="invalidi = ''; trysearch()"
              pattern="[A-Za-z0–9\-]+"
            />
            <div class="t-validation-message">
              <span>Invalid ID Number</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="First Name"
              [ngClass]="invalidf"
              [(ngModel)]="first"
              (keyup)="invalidf = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in first name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="Last Name"
              [ngClass]="invalidl"
              [(ngModel)]="last"
              (keyup)="invalidl = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in last name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="tel"
              class="search-patient-field"
              placeholder="Phone"
              [(ngModel)]="phone"
            />
            <div class="t-validation-message">
              <span>Invlid phone</span>
            </div>
          </div>

          <div class="l-flex l-flex-w t-fieldmargin search-btns">
            <div class="w100" *ngIf="loginService.showAWL()">
              <button
                class="search-btn"
                (click)="AWL(); isReports = false"
                matTooltip="Artisan Worklist"
              >
                TodayList
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                [disabled]="isSearchButtonDisabled"
                (click)="search(true); isReports = false"
                matTooltip="Search Patient"
              >
                Search
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                (click)="clear()"
                [ngClass]="
                  id.length > 0 ||
                  last.length > 0 ||
                  first.length > 0 ||
                  phone.length > 0
                    ? ''
                    : 'search-btn--clear'
                "
                matTooltip="Clear Search Fields"
              >
                Clear
              </button>
            </div>
            <div class="all-sites-warning" *ngIf="sites.activeSite === 'all'">
              <span class="all-sites-warning-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M4 7h13M17 7l-3-3M17 7l-3 3M20 17H7M7 17l3 3M7 17l3-3"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              Select a specific site to create a new patient
            </div>
            <div class="w100">
              <button
                class="search-btn search-btn--newPatient"
                (click)="addPatient(); isReports = false"
                [disabled]="sites.activeSite === 'all'"
                matTooltip="Open New Patient"
              >
                New Patient
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                matTooltip="Search Exams"
                (click)="openEsearch = true; isReports = false"
              >
                Search Exams
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                matTooltip="Reports"
                *ngIf="loginService.userType == 'secretary'"
                (click)="openEsearch = true; isReports = true"
              >
                Reports
              </button>
            </div>
          </div>
        </div>

        <div class="search-help">
          Need help?
          <button class="open-help" (click)="openHelp()">Click Here</button>
        </div>
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->

  <!-- ===================================== POPUP : HELP (START) =============================================== -->

  <!-- Sites: per-clinic workload popup -->
  <div
    class="t-popup popup-help"
    *ngIf="showSiteStats"
    style="display: inherit"
  >
    <div class="t-popup-close"></div>
    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="showSiteStats = false"
        ></button>
        <h2>Waiting for Interpretation - by Site</h2>
        <div *ngIf="siteStatsLoading" style="padding: 1em 0; color: #6a7d82">
          Loading…
        </div>
        <table
          *ngIf="!siteStatsLoading && siteCounts.length > 0"
          class="site-stats-table"
        >
          <thead>
            <tr>
              <th>Site</th>
              <th>Waiting</th>
              <th>In Progress</th>
              <th>Signed Today</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let c of siteCounts"
              class="site-stats-row"
              (click)="filterToSite(c.GID)"
              matTooltip="Show this site's list"
            >
              <td>{{ c.ClinicTitle }}</td>
              <td>
                <strong>{{ c.Waiting }}</strong>
              </td>
              <td>{{ c.InProgress }}</td>
              <td>{{ c.SignedToday }}</td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="!siteStatsLoading && siteCounts.length === 0"
          style="padding: 1em 0; color: #6a7d82"
        >
          No sites to report.
        </div>
      </div>
    </div>
  </div>

  <div class="t-popup popup-help" *ngIf="showhelp">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="showhelp = false"
        ></button>

        <h2>Help</h2>

        <section class="part-help">
          <h3>Search</h3>

          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web
          page editors now use Lorem Ipsum as their default model text, and a
          search for 'lorem ipsum' will uncover many web sites still in their
          infancy. Various versions have evolved over the years, sometimes by
          accident, sometimes on purpose (injected humour and the like).
        </section>
      </div>
    </div>
  </div>
  <div class="t-popup popup-help" *ngIf="carderror" style="display: inherit">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="carderror = null"
        ></button>

        <h2 style="direction: rtl; margin-right: 3em">
          מטופל עם ת.ז. {{ carderror }} לא נמצאה ברשימת המוזמנים להיום.
        </h2>

        <section class="part-help">
          <h3 style="direction: rtl">נא לבדוק נכונות המספר ולנסות שוב</h3>
        </section>
      </div>
    </div>
  </div>

  <!-- <div class="t-popup popup-help" *ngIf="tocopy" style="display: inherit">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="toreassign=null;AWL()"></button>
    
                    <h2>
                        Warning!
                    </h2>
    
                    <section class="part-help">
    
                        <h3>
                            This will remove {{toreassign.First + ' ' + toreassign.Last}} from {{loginService.getDocByUID(toreassign.UID)}} and make her a patient of {{loginService.getDocByUID(toreassign.nUID)}}.
                        </h3>
                        <button (click)="reassign()">OK</button>    
                        <button style="float:right" (click)="toreassign=null;AWL()">Cancel</button> 
                    </section>                 
                </div>
            </div>
        </div>--->

  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [pat]="exServ.patServ.getPat()"
    [form]="concentForm"
  ></app-informconcent>

  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [isnew]="false"
  ></app-loginbox>
  <app-patdetails
    *ngIf="selectedPatient && !typeForm"
    [pat]="selectedPatient"
    [awl]="chosenAWL"
    [awlExam]="awlExamType"
    [awlTime]="awlTime"
    [awlLMP]="awlLMP"
    [awlComment]="awlComment"
    [openWAWL]="loginService.barcodeScan"
    (closed)="onClosed($event)"
    (showpay)="paymentNoCard()"
  ></app-patdetails>
  <app-payment
    *ngIf="showpayment"
    [tz]="showpayment"
    [idtype]="idcode"
    [awlid]="selectedPatient.AWLID"
    [exp]="expcode"
    (closed)="showpayment = null"
  ></app-payment>
  <app-searchbox
    *ngIf="openEsearch"
    (closed)="searchClosed($event)"
    (closeReports)="searchXml($event)"
    [isReports]="isReports"
    [hmostype]="hmostype"
    [isGastro]="loginService.isGastro"
    [startdate]="fromd"
    [enddate]="tod"
    [examtype]="examMode"
    [exams]="examVals"
  ></app-searchbox>
  <app-commerror></app-commerror>
  <app-printopts
    *ngIf="showprint"
    (closed)="showprint = false"
    [showopts]="showprintopts"
    [stats]="true"
    [isReport]="true"
    [type]="reportName"
    [startdate]="fromd"
    [enddate]="tod"
    [hmostype]="hmostype"
  >
  </app-printopts>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="showSendQuestionnaire = false; selectedPatient = null"
  ></app-send-questionnaire>
</div>
